export interface IntegrityMonitorAssignRulesFormWebComponentSchema {
  ruleSetOptions: Array<RuleSetOption>;
}

export interface RuleSetOption {
  _id: string;
  name: string;
}

export enum AssignRulesFormEvents {
  ASSIGNED_RULES = 'assignedRules',
}
